import { GeosetsEditPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeosetsEditRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      requireGeoset
      permission="journeys/geofences/edit"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeosetsEditPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/edit')({
  component: GeosetsEditRoute,
});
